import { ManagementSubscriptionDTO } from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';

export enum EmployeeSubscriptionActionTypes {
    LoadSubscriptionsByEmployee = '[EmployeeSubscription] Load Subscriptions By Employee',

    LoadSubscriptionsSuccess = '[EmployeeSubscription] Load Subscriptions Success',
    LoadSubscriptionsFailure = '[EmployeeSubscription] Load Subscriptions Failure',

    UpsertInsuranceNumber = '[EmployeeSubscription] UpsertInsuranceNumber',
    UpsertInsuranceNumberSuccess = '[EmployeeSubscription] UpsertInsuranceNumberSuccess',
    UpsertInsuranceNumberFailure = '[EmployeeSubscription] UpsertInsuranceNumberFailure',

    UpdateSubscriptionsDate = '[EmployeeSubscription] Update Subscriptions Date',
    ToggleSubscription = '[EmployeeSubscription] Toggle Subscription',

    SelectTransactionSubscription = '[EmployeeSubscription] Select Transaction Subscription',
    ResetTransactionSubscription = '[EmployeeSubscription] Reset Transaction Subscription'
}

export const LoadSubscriptionsByEmployee = createAction(
    EmployeeSubscriptionActionTypes.LoadSubscriptionsByEmployee,
    props<{ employeeId: string }>()
);

export const LoadSubscriptionsSuccess = createAction(
    EmployeeSubscriptionActionTypes.LoadSubscriptionsSuccess,
    props<{ subscriptions: ManagementSubscriptionDTO[] }>()
);
export const LoadSubscriptionsFailure = createAction(EmployeeSubscriptionActionTypes.LoadSubscriptionsFailure, props<{ error: any }>());

export const UpsertInsuranceNumber = createAction(
    EmployeeSubscriptionActionTypes.UpsertInsuranceNumber,
    props<{ employeeProductSubscriptionId: string; insuranceNumber: string }>()
);
export const UpsertInsuranceNumberSuccess = createAction(
    EmployeeSubscriptionActionTypes.UpsertInsuranceNumberSuccess,
    props<{ employeeId: string }>()
);
export const UpsertInsuranceNumberFailure = createAction(
    EmployeeSubscriptionActionTypes.UpsertInsuranceNumberFailure,
    props<{ error: any }>()
);

export const UpdateSubscriptionsDate = createAction(EmployeeSubscriptionActionTypes.UpdateSubscriptionsDate, props<{ date: string }>());
export const ToggleSubscription = createAction(
    EmployeeSubscriptionActionTypes.ToggleSubscription,
    props<{ subscriptionId: string; subSubscriptionId?: string }>()
);

export const ResetTransactionSubscription = createAction(EmployeeSubscriptionActionTypes.ResetTransactionSubscription);
export const SelectTransactionSubscription = createAction(
    EmployeeSubscriptionActionTypes.SelectTransactionSubscription,
    props<{ subscriptionId: string; subSubscriptionId: string }>()
);
